import { Outlet, useParams } from 'react-router-dom'

import { DocumentTemplateDetailsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import MainContent from 'modules/documents/components/DocumentTemplates/DocumentTemplateDetails/MainContent'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DocumentTemplateDetailsPage = () => {
  const { documentTemplateId } = useParams()
  const { loading, data, error } = useQuery(DocumentTemplateDetailsDocument, {
    variables: { id: String(documentTemplateId) },
  })

  const documentTemplate = data?.documents?.template
  const taskConfigurations =
    data?.processes.taskConfigurationSendDocumentTemplatesConnection.nodes ?? []
  const authorized =
    data?.documents._policies?.templateManageDocumentTemplates.can && documentTemplate != null

  return (
    <>
      <ResponsivePage.Body
        variant="full"
        loading={loading}
        error={error}
        showHeader={false}
        authorized={authorized}
      >
        {documentTemplate && (
          <MainContent
            documentTemplate={documentTemplate}
            taskConfigurations={taskConfigurations}
          />
        )}
      </ResponsivePage.Body>
      <Outlet />
    </>
  )
}

export default DocumentTemplateDetailsPage
